<div class="popup-backdrop" *ngIf="show">
  <div class="popup" [ngClass]="globalPopup ? 'popup-global' : 'popup-with-sidebar'">
    <h2>{{ title | translate }}</h2>
    <p>{{ message | translate }}</p>

    <div class="actions">
      <button *ngIf="!alert" class="btn cancel" (click)="onClose()">{{'no' | translate}}</button>
      <button *ngIf="alert" class="btn cancel" (click)="onClose()">Ok</button>
      <button *ngIf="!alert" class="btn confirm" (click)="onConfirm()">{{'yes' | translate}}</button>
    </div>
  </div>
</div>
